import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { CountriesService } from '@shared/services/countries.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';
import { provideNgxMask } from 'ngx-mask';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@signup/public/public.module').then((m) => m.PublicModule),
    resolve: {
      countries: CountriesService
    }
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      preloadingStrategy: CustomPreloadingStrategy
    }),
  ],
  exports: [RouterModule],
  providers: [provideNgxMask()]
})
export class CoreRoutingModule {}
